import { reMobileDevice, reMobileDevice2 } from '@Managers/Device/UseWindowDimensions.types';

export const getDevicePixelRatio = (): number => {
    const DPR = window.devicePixelRatio;
    const isMobile = reMobileDevice.test(navigator.userAgent) || reMobileDevice2.test(navigator.userAgent.substr(0, 4));

    if (isMobile) return DPR;

    if (window.innerWidth >= 1280 && window.innerWidth < 2560 && window.innerHeight >= 720 && window.innerHeight < 1440) return Math.min(DPR, 2);

    if (window.innerWidth >= 2560 && window.innerHeight >= 1440) return DPR;

    return DPR;
};
